module.exports = __webpack_public_path__ + "static/media/reloj-01.8d8834ed.svg";